import { pluginRegistry } from '@/PluginRegistry';
import { DashboardControl } from './controls/dashboard-control/DashboardControl';
import { InvoicesControl } from './controls/invoices-control/InvoicesControl';
import { PaymentMethodsControl } from './controls/payment-methods-control/PaymentMethodsControl';
import { SubscriptionsControl } from './controls/subscriptions-control/SubscriptionsControl';

pluginRegistry.register('dashboardControl', DashboardControl);
pluginRegistry.register('subscriptionsControl', SubscriptionsControl);
pluginRegistry.register('invoicesControl', InvoicesControl);
pluginRegistry.register('paymentMethodsControl', PaymentMethodsControl);
